import { Button, Col, Form, Row } from "react-bootstrap";
import { formatDate, formatMoeda, getUuidV4, goToFocus, rgx_money, rgx_numberOnly } from "../../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { infPagInterface, InfPrazoInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { format } from "date-fns";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: InfPrazoInterface = {
    id: 0,
    dVenc: format(new Date(), 'yyyy-MM-dd'),
    nParcela: '',
    vParcela: 0
}
interface formProps {
    form: infPagInterface;
    setForm: React.Dispatch<React.SetStateAction<infPagInterface>>
}

const PrazoPagto: React.FC<formProps> = ({ form, setForm }) => {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [formPrazo, setFormPrazo] = useState<InfPrazoInterface>(initialForm);
    const [saldo, setSaldo] = useState(form.vContrato);
    const vParcelaRef = useRef<HTMLInputElement>(null);
    const nParcelaRef = useRef<HTMLInputElement>(null);
    const dVencRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        const transformers: Record<string, (val: string) => string> = {
            nParcela: rgx_numberOnly,
            vParcela: rgx_money,
        };

        const newValue = transformers[name] ? transformers[name](value) : value;
        setFormPrazo(prev => ({ ...prev, [name]: newValue }));
    }

    const validarPreenchimento = () => {

        if (formPrazo.nParcela === "") {
            goToFocus(nParcelaRef);
            alertModal('Informe o numero da parcela.');
            return false;
        }

        if (formPrazo.dVenc === "") {
            goToFocus(dVencRef);
            alertModal('Informe a data de vencimento.');
            return false;
        }

        if (formPrazo.vParcela === 0) {
            goToFocus(vParcelaRef);
            alertModal('Informe o valor da parcela');
            return false;
        }

        if (form.indPag === 0) {
            alertModal('Somente pode adicionar em caso de Ind. Forma Pagto for a prazo.');
            return false;
        }

        if (form.vContrato === 0) {
            alertModal('Informe o valor do contrato.');
            return false;
        }

        if (saldo === 0) {
            alertModal('A somatoria dos prazos atingiu o valor do contrato');
            return false;
        }

        if (formPrazo.vParcela > saldo) {
            alertModal('Vlr. da parcela maior que o saldo restante. Informe o valor menor ou igual ao saldo.');
            return false;
        }

        if (form.infPrazo && form.infPrazo?.length > 0) {
            if (form.infPrazo.find(item => item.nParcela === formPrazo.nParcela)) {
                goToFocus(nParcelaRef);
                alertModal('Número de parcela já adicionado.');
                return false;
            }
        }
        return true;
    }

    const handleAddPrazo = () => {
        if (validarPreenchimento()) {
            setForm({
                ...form,
                infPrazo: [...(form.infPrazo || []), {
                    id: getUuidV4(),
                    dVenc: formPrazo.dVenc,
                    nParcela: formPrazo.nParcela,
                    vParcela: formPrazo.vParcela
                }]
            });
            setFormPrazo(initialForm);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>
        })
        if (confirmed) {
            setForm({
                ...form,
                infPrazo: form.infPrazo?.filter((item: InfPrazoInterface) => item.id !== value.id)
            })
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (form.infPrazo && form.infPrazo.length > 0) {
            const confirmed = await confirm({
                title: "Confirmação",
                message: <>Remover todos ?</>
            })
            if (confirmed) {
                setForm({
                    ...form,
                    infPrazo: []
                })
            }
        }
    }

    useEffect(() => {
        const total = form.infPrazo?.map((item: InfPrazoInterface) =>
            item.vParcela).reduce((total, num) => total + parseFloat(num.toString()), 0) || 0;
        setSaldo(form.vContrato - total);

    }, [form.vContrato, form.infPrazo])

    return (<>
        <Row className="mb-3 g-2">
            <Col md>
                <Form.Group controlId="nParcela">
                    <Form.Label>Num. Parcela</Form.Label>
                    <Form.Control name="nParcela" value={formPrazo.nParcela} maxLength={3}
                        ref={nParcelaRef}
                        onChange={handleChange} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group controlId="dVenc">
                    <Form.Label>Data Vencto</Form.Label>
                    <Form.Control name="dVenc" value={formPrazo.dVenc} type="date"
                        ref={dVencRef}
                        onChange={handleChange} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group controlId="vParcela">
                    <Form.Label>Vlr. Parcela</Form.Label>
                    <Form.Control name="vParcela" value={formPrazo.vParcela} type="number" maxLength={16}
                        ref={vParcelaRef}
                        onChange={handleChange}
                    />
                </Form.Group>
            </Col>
        </Row>

        <Row className="g-2 mb-3">
            <Col md className="d-flex align-items-end">
                <Button title="Adicionar Prazo" onClick={handleAddPrazo}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>
            <Col md={'auto'} className="d-flex align-items-center ">
                <Form.Label className="mb-0">Saldo Vlr Contrato</Form.Label>
            </Col>
            <Col md={'auto'}>
                <Form.Control value={formatMoeda(saldo)} disabled
                />
            </Col>
        </Row>

        <JTable>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>Num. parcela</th>
                    <th>Data Vencto</th>
                    <th>Vlr. Parcela</th>
                </tr>
            </JTHead>
            <JTBody>
                {form.infPrazo?.map((item: InfPrazoInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover
                                onClick={() => handleRemover({ id: item.id.toString(), title: item.nParcela })} />
                        </td>
                        <td>{item.nParcela}</td>
                        <td>{formatDate(item.dVenc)}</td>
                        <td>{formatMoeda(item.vParcela)}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
export default PrazoPagto;